import { prop } from 'ramda';

import { permissionsAdapter } from '@/adapters';

export const permissionsEntitySelector = permissionsAdapter.getSelectors<RootState>(
  prop('permissions'),
);
